import { client } from '@/libs/openApi'

import { AddressSuggestionsParams } from '../types'

export const getAddressSuggestion = async (params: AddressSuggestionsParams) => {
	const { data } = await client.GET('/address/zip', {
		params: { query: { ...params } },
	})

	return data
}
